import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import PC from '@/views/LoginPc.vue';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/pc'
    },
    {
        path: '/pc',
        name: 'pc',
        component: PC
    },
    {
        path: '/phone',
        name: 'phone',
        // route level code-splitting
        // this generates a separate chunk (phone.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "phone" */ '@/views/LoginPhone.vue')
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
